import Vue from 'vue'
import axios from 'axios'
import utils from '@/utils/index'
import p from '@/utils/secretkey/p'
import pfile from '@/utils/secretkey/pfile'
import store from '@/store/index'
import config from '@/utils/config/index'
import EquipmentDialog from '@/components/Dialog/EquipmentDialog'
import Fingerprint2 from 'fingerprintjs2' // 引入fingerprintjs2

var equipmentInstance = null
var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥
function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}
let root =
  process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_API_URL

async function createFingerprint() {
  // 选择哪些信息作为浏览器指纹生成的依据
  const options = {
    fonts: {
      extendedJsFonts: true,
    },
    excludes: {
      audio: true,
      userAgent: true,
      enumerateDevices: true,
      touchSupport: true,
    },
  }

  // 使用 Promise 包装 Fingerprint2.get，以便能够等待它完成
  const fingerprint = new Promise(resolve => {
    Fingerprint2.get(options, components => {
      const values = components.map(component =>
        component.key != 'pixelRatio' ? component.value : ''
      )
      const murmur = Fingerprint2.x64hash128(
        values.join('') + window.location.host,
        31
      )
      resolve(murmur)
    })
  })
  // 1. 获取12位的aes key
  var ak = utils.genak()

  const murmur = await fingerprint

  let row = {
    device_key: murmur,
  }
  var parShort = utils.secret(row, ak)
  var ptoShort = utils.re(ak, unescape(escape(p)))
  if (!localStorage.getItem('parShort')) {
    localStorage.setItem('parShort', parShort)
    localStorage.setItem('ptoShort', ptoShort)
  }
}
function createDiv(id) {
  let isExit = document.querySelector('#' + id)
  if (!isExit) {
    let isExit = document.createElement('div')
    isExit.id = id
    document.body.appendChild(isExit)
  }
  return isExit
}

function createModel(id, model) {
  createDiv(id)
  const dialogModel = Vue.extend(model)
  return new dialogModel().$mount('#' + id)
}
const xiaxianDiaShow = _.debounce(
  () => {
    equipmentInstance = createModel('equipmentDia', EquipmentDialog)
    equipmentInstance.handleOpen()
  },
  300,
  {
    leading: true,
    trailing: false,
  }
)
await createFingerprint()
const service = axios.create({
  baseURL: root,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    par: localStorage.getItem('parShort'),
    pto: localStorage.getItem('ptoShort'),
    os: 'pc',
  },
})

service.interceptors.request.use(config => {
  // 每次请求前动态获取最新的AuthToken
  config.headers['AuthToken'] = localStorage.getItem('shortToken') || ''
  if (config.method === 'post') {
    // 将 JSON 数据转换为 FormData
    const formData = new FormData()
    for (const key in config.data) {
      formData.append(key, config.data[key])
    }
    // 更新请求配置，使用 FormData 格式的数据
    config.data = formData

    // 更新请求头，指定使用 FormData 格式
    // config.headers["Content-Type"] = "multipart/form-data";
  }
  return config
})

service.interceptors.response.use(
  async response => {
    //被下线
    if (response.data?.status == 1012) {
      store.commit('clearUserData')
      localStorage.removeItem('platfro')
      localStorage.removeItem('shortToken')
      localStorage.removeItem('shortLogin')
      utils.clearCookie(config.fmCookieName)
      xiaxianDiaShow()
      response.data.msg = ''
    }
    //请重新登录
    if (response.data?.status == 10020) {
      store.commit('clearUserData')
      localStorage.removeItem('platfro')
      localStorage.removeItem('shortToken')
      localStorage.removeItem('shortLogin')
      utils.clearCookie(config.fmCookieName)
    }
    //清空pto2
    if (response.data?.status == 40100) {
      localStorage.removeItem('parShort')
      localStorage.removeItem('ptoShort')
      createFingerprint()
    }
    return response.data
  },
  err => {
    return {
      status: -1,
    }
    // return Promise.reject(error);
  }
)

export default service
